import { z } from 'zod';

/**
 * Shared search parameter schema for published swimlane routes.
 *
 * Optional query parameters for export mode:
 * - export: '1' to enable export mode
 * - title: '0' to hide title
 * - branding: '0' to hide branding/logo
 * - date: '0' to hide publish date
 * - legend: '0' to hide legend
 * - vision: Custom vision statement text
 */
export const publishedSwimlaneSearchSchema = z.object({
  export: z.string().optional(),
  title: z.string().optional(),
  branding: z.string().optional(),
  date: z.string().optional(),
  legend: z.string().optional(),
  vision: z.string().optional(),
});

export type PublishedSwimlaneSearchParams = z.infer<typeof publishedSwimlaneSearchSchema>;
